import { Marketplace } from 'app/graphql/generated/admin/graphql';

export const marketplaceEnumToString = (marketplace: Marketplace): 'amazon' | 'shopify' => {
  switch (marketplace) {
    case Marketplace.Amazon:
      return 'amazon';
    case Marketplace.Shopify:
      return 'shopify';
    default:
      throw new Error(`Unsupported marketplace: ${marketplace}`);
  }
};

export const marketplaceStringToEnum = (marketplace: 'amazon' | 'shopify'): Marketplace => {
  switch (marketplace) {
    case 'amazon':
      return Marketplace.Amazon;
    case 'shopify':
      return Marketplace.Shopify;
    default:
      throw new Error(`Unsupported marketplace: ${marketplace}`);
  }
};
